import { useQuery } from '@tanstack/react-query';
import { getAnalyticsOverview, getRefereeRoster, getRefereeDetail } from '../services/analytics.service';

// The federation-admin analytics dashboard. A single query backs the whole page; a short stale
// window since the figures shift as referees answer through the day (compute-on-read, not cached).
export function useAnalyticsOverview(enabled = true) {
  return useQuery({
    queryKey: ['analytics', 'overview'],
    queryFn: getAnalyticsOverview,
    enabled,
    staleTime: 60_000,
  });
}

// The admin roster behind the Referees tab. Same short stale window as the dashboard — the figures
// move as referees answer through the day.
export function useRefereeRoster() {
  return useQuery({
    queryKey: ['analytics', 'referees'],
    queryFn: getRefereeRoster,
    staleTime: 60_000,
  });
}

// One referee's profile. Disabled until an id is present so the hook can sit unconditionally at the
// top of a route component that is still resolving its param.
export function useRefereeDetail(userId: string | undefined) {
  return useQuery({
    queryKey: ['analytics', 'referees', userId],
    queryFn: () => getRefereeDetail(userId!),
    enabled: Boolean(userId),
    staleTime: 60_000,
  });
}
